import React, { useState } from 'react';
import { ErrorMessage, Field } from 'formik';
import Proptypes from 'prop-types';
import { formErrorMessage } from './FormErrorMessage';

import styled from 'styled-components';
import DatePicker from '../datePicker/DatePicker';

import { CustomDropdownStyle } from '../styledComponents/StyledCustomDropdown';
import moment from 'moment';
import CalenderIcon from '../svgIcons/CalenderIcon';

const formatDate = (date = '') =>
  date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : date;

const FormikDatePicker = ({
  name,
  placeholder = 'Enter delivery date',
  onChange = () => {},
  disableDate = false,
  disableYear = false,
  enableFrom = undefined,
  ...props
}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const toggleShowPicker = () => setShowDatePicker(!showDatePicker);

  return (
    <Field name={name}>
      {({ field: { value, name }, form: { setFieldValue, submitCount } }) => (
        <>
          <CustomDropdownStyle
            show={showDatePicker}
            name={name}
            toggleClassName={'table-dropdown ms-0 table-text'}
            className="custom-drop-down custom-drop-down-width table-dropdown-custom calendar-dropdown topic-dropdown bg-white"
            dropdownToggle={
              <span className="flex-center p-2 w-100 justify-content-between">
                <DropdownPlaceHolder className="me-1 me-lg-2 mb-0 ">
                  {value ? moment(value).format('MMM DD, yyyy') : placeholder}
                </DropdownPlaceHolder>
                <CalenderIcon />
              </span>
            }
            dropDownToggleProps={{
              onClick: () => toggleShowPicker(),
            }}
            dropdownMenu={
              <DatePicker
                disableYear={disableYear}
                disableDate={disableDate}
                enableFrom= {enableFrom}
                name={`${name}-datePicker`}
                selectedDate={moment(value).toDate()}
                onOutsideClick={() => setShowDatePicker(false)}
                onChange={(date) => {
                  setFieldValue(name, formatDate(date));
                  onChange(name, formatDate(date));
                  // toggleShowPicker();
                }}
                {...props}
              />
            }
          />

          {submitCount > 0 && (
            <ErrorMessage name={name} render={formErrorMessage} />
          )}
        </>
      )}
    </Field>
  );
};

FormikDatePicker.propTypes = {
  name: Proptypes.string.isRequired,
  placeholder: Proptypes.string,
  type: Proptypes.string,
  as: Proptypes.string,
  rows: Proptypes.string,
};

const DropdownPlaceHolder = styled.h6`
  color: ${({ theme }) => theme.placeholderColor} !important;
  font-family: ${({ theme }) => theme.fontFamily} !important;
  font-size: ${({ theme }) => theme.fontSize || '16px'} !important;
`;

export default React.memo(FormikDatePicker);
